import React, { Component } from 'react';
import imageTop from '../../../assets/images/bg-top@2x.png';

import './index.scss';

class HeaderNav extends Component {
  render() {
    const Classes = `HeaderNav ${ this.props.className ? this.props.className : '' }`
    return (
      <header
        className={ Classes }
        style={{ backgroundImage: `url(${ imageTop })` }}
      >
        <div className="Content Wrapper" style={this.props.padd ? {...this.props.padd} : {}}>
          {
            this.props.children
          }
        </div>
      </header>
    )
  }
}

export default HeaderNav;
